import DashboardIcon from "./Components/DashboardNav/Icons/DashboardIcon";
import MatchingIcon from "./Components/DashboardNav/Icons/MatchingIcon";
import AccountIcon from "./Components/DashboardNav/Icons/AccountIcon";
// import ExitIcon from "./Components/DashboardNav/Icons/ExitIcon";

const Links = [
  {
    linkName: "Dashboard",
    to: "/dashboard/",
    icon: <DashboardIcon />,
  },
  {
    linkName: "Matching Criteria",
    to: "/dashboard/matching-criteria",
    icon: <MatchingIcon />,
  },
  {
    linkName: "Account",
    to: "/dashboard/account",
    icon: <AccountIcon />,
  },
  // {
  //     linkName: "Sign Out",
  //     to: "/",
  //     icon: <ExitIcon />
  // }
];

export default Links;
